// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27m6 8 4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.high-court-case-form-container {
  min-height: 100vh;
  background: #f9fafb;
  padding: 2rem;
}
.high-court-case-form-container .rem-div-btn,
.high-court-case-form-container .add-div-btn {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.5rem;
}
.high-court-case-form-container .court-remove-case {
  padding: 0.5rem 1rem;
  background-color: #e74c3c;
  color: white;
  border: none;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
}
.high-court-case-form-container .court-remove-case:hover {
  background-color: #dc2626;
}
.high-court-case-form-container .court-add-case {
  padding: 0.5rem 1rem;
  background-color: #5cb85c;
  color: white;
  border: none;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  margin-top: 0.5rem;
}
.high-court-case-form-container .court-add-case:hover {
  background-color: #16a34a;
}
@media (max-width: 768px) {
  .high-court-case-form-container {
    padding: 1rem;
  }
}
.high-court-case-form-container .hc-form-header {
  text-align: center;
  margin-bottom: 2rem;
}
.high-court-case-form-container .hc-form-header .hc-form-title {
  font-weight: 500;
  color: #374151;
  margin-bottom: 0.5rem;
  font-size: 1.3rem;
}
@media (max-width: 768px) {
  .high-court-case-form-container .hc-form-header .hc-form-title {
    font-size: 1.25rem;
  }
}
.high-court-case-form-container .hc-form-header .hc-form-subtitle {
  font-size: 0.875rem;
  color: #6b7280;
  font-weight: 400;
}
.high-court-case-form-container form {
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  padding: 1.5rem;
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.high-court-case-form-container form h2 {
  font-weight: 500;
  margin: 0 0 1rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
  font-size: 1rem;
}
@media (max-width: 768px) {
  .high-court-case-form-container form {
    padding: 1rem;
    margin: 1rem;
  }
}
.high-court-case-form-container .div-rem {
  background: #f9fafb;
  border-radius: 0.375rem;
  padding: 1rem;
  margin-bottom: 1rem;
  border: 1px solid #f3f4f6;
  transition: all 0.3s ease-in-out;
}
.high-court-case-form-container .div-rem.collapsed {
  padding: 0.75rem 1rem;
}
.high-court-case-form-container .div-rem:last-child {
  margin-bottom: 0;
}
@media (max-width: 768px) {
  .high-court-case-form-container .div-rem {
    padding: 0.75rem;
  }
}
.high-court-case-form-container .summary-view {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 1rem;
}
.high-court-case-form-container .summary-view .summary-details {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  font-size: 0.875rem;
  overflow: hidden;
}
.high-court-case-form-container .summary-view .summary-details .summary-item {
  display: flex;
  gap: 0.35rem;
}
.high-court-case-form-container .summary-view .summary-details .summary-label {
  color: #6b7280;
  font-weight: 500;
}
.high-court-case-form-container .summary-view .summary-details .summary-value {
  color: #111827;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.high-court-case-form-container .summary-view .summary-actions {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
.high-court-case-form-container .summary-view .summary-actions .edit-btn {
  padding: 0.5rem 1rem;
  background-color: #3b82f6;
  color: white;
  border: none;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.2s;
}
.high-court-case-form-container .summary-view .summary-actions .edit-btn:hover {
  background-color: #2563eb;
}
.high-court-case-form-container .other-court-form-group {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}
.high-court-case-form-container .other-court-form-group:last-child {
  margin-bottom: 0;
}
@media (max-width: 768px) {
  .high-court-case-form-container .other-court-form-group {
    flex-direction: column;
    gap: 0.5rem;
  }
}
.high-court-case-form-container .other-court-form-group .form-det {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}
.high-court-case-form-container .other-court-form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.high-court-case-form-container .other-court-form-group label .user-form-required {
  color: #ef4444;
  margin-left: 0.25rem;
}
.high-court-case-form-container .other-court-form-group input,
.high-court-case-form-container .other-court-form-group textarea,
.high-court-case-form-container .other-court-form-group select {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
  height: 2.5rem;
}
.high-court-case-form-container .other-court-form-group input:focus,
.high-court-case-form-container .other-court-form-group textarea:focus,
.high-court-case-form-container .other-court-form-group select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.high-court-case-form-container .other-court-form-group input:hover:not(:focus),
.high-court-case-form-container .other-court-form-group textarea:hover:not(:focus),
.high-court-case-form-container .other-court-form-group select:hover:not(:focus) {
  border-color: #9ca3af;
}
.high-court-case-form-container .other-court-form-group input::placeholder,
.high-court-case-form-container .other-court-form-group textarea::placeholder,
.high-court-case-form-container .other-court-form-group select::placeholder {
  color: #9ca3af;
}
.high-court-case-form-container .other-court-form-group input:disabled,
.high-court-case-form-container .other-court-form-group textarea:disabled,
.high-court-case-form-container .other-court-form-group select:disabled {
  background-color: #f9fafb;
  color: #6b7280;
  cursor: not-allowed;
}
.high-court-case-form-container .other-court-form-group select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5rem 1.5rem;
  padding-right: 2.5rem;
}
.high-court-case-form-container .other-court-form-group input[type=date] {
  cursor: pointer;
}
.high-court-case-form-container .other-court-form-group input[type=date]::-webkit-calendar-picker-indicator {
  cursor: pointer;
  opacity: 0.6;
}
.high-court-case-form-container .other-court-form-group input[type=date]::-webkit-calendar-picker-indicator:hover {
  opacity: 0.8;
}
.high-court-case-form-container .other-court-form-group textarea {
  height: auto;
  min-height: 4rem;
  resize: vertical;
  line-height: 1.5;
}
.high-court-case-form-container .form-row {
  margin-bottom: 1rem;
}
.high-court-case-form-container .form-row:last-child {
  margin-bottom: 0;
}
@media (max-width: 768px) {
  .high-court-case-form-container .form-row .other-court-form-group {
    flex-direction: column;
    gap: 0.5rem;
  }
}
.high-court-case-form-container .oc-submit-section {
  position: fixed;
  bottom: 2rem;
  left: 88%;
  transform: translateX(-149.5%);
  z-index: 1000;
}
.high-court-case-form-container .oc-submit-section.hidden {
  opacity: 0;
  pointer-events: none;
}
@media (max-width: 768px) {
  .high-court-case-form-container .oc-submit-section {
    bottom: 1rem;
    left: 1rem;
    right: 1rem;
    transform: none;
  }
}
.high-court-case-form-container .oc-submit-section .submit-btn {
  padding: 0.75rem 1rem;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 0.25rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  min-width: 150px;
  margin: 1.5rem auto 0;
  display: block;
}
.high-court-case-form-container .oc-submit-section .submit-btn:hover {
  background-color: #005a9a;
}
.high-court-case-form-container .oc-submit-section .submit-btn:active {
  transform: translateY(0);
}
.high-court-case-form-container .oc-submit-section .submit-btn:focus {
  outline: none;
}
.high-court-case-form-container .oc-submit-section .submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}
.high-court-case-form-container .oc-submit-section .submit-btn:disabled:hover {
  transform: none;
}
@media (max-width: 768px) {
  .high-court-case-form-container .oc-submit-section .submit-btn {
    width: 100%;
    border-radius: 25px;
    min-width: unset;
    font-size: 0.95rem;
    padding: 0.875rem 1.25rem;
  }
}
.high-court-case-form-container .oc-submit-section-form {
  display: flex;
  justify-content: end;
  margin-top: 1.5rem;
  border-top: 1px solid #e5e7eb;
}
@media (max-width: 768px) {
  .high-court-case-form-container .oc-submit-section-form {
    flex-direction: column;
  }
}
.high-court-case-form-container .oc-submit-section-form .submit-btn {
  padding: 0.75rem 1rem;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 0.25rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  min-width: 150px;
  margin-top: 1rem;
  display: block;
}
.high-court-case-form-container .oc-submit-section-form .submit-btn:hover {
  background-color: #005a9a;
}
.high-court-case-form-container .oc-submit-section-form .submit-btn:active {
  transform: translateY(1px);
}
.high-court-case-form-container .oc-submit-section-form .submit-btn:focus {
  outline: none;
}
.high-court-case-form-container .oc-submit-section-form .submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
@media (max-width: 768px) {
  .high-court-case-form-container .oc-submit-section-form .submit-btn {
    width: 100%;
    margin-top: 1rem;
  }
}
.high-court-case-form-container .hc-empty-state {
  text-align: center;
  padding: 2rem;
  background: #f9fafb;
  border-radius: 0.375rem;
  border: 2px dashed #e5e7eb;
  margin-bottom: 1rem;
}
.high-court-case-form-container .hc-empty-state .hc-empty-text {
  color: #6b7280;
  font-style: italic;
  font-size: 0.875rem;
}
.high-court-case-form-container .hc-array-actions {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}
.high-court-case-form-container .hc-array-actions .hc-add-btn,
.high-court-case-form-container .hc-array-actions .hc-remove-btn {
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  border: none;
}
.high-court-case-form-container .hc-array-actions .hc-add-btn.hc-add-btn,
.high-court-case-form-container .hc-array-actions .hc-remove-btn.hc-add-btn {
  background-color: #5cb85c;
  color: white;
}
.high-court-case-form-container .hc-array-actions .hc-add-btn.hc-add-btn:hover,
.high-court-case-form-container .hc-array-actions .hc-remove-btn.hc-add-btn:hover {
  background-color: #16a34a;
}
.high-court-case-form-container .hc-array-actions .hc-add-btn.hc-remove-btn,
.high-court-case-form-container .hc-array-actions .hc-remove-btn.hc-remove-btn {
  background-color: #e74c3c;
  color: white;
}
.high-court-case-form-container .hc-array-actions .hc-add-btn.hc-remove-btn:hover,
.high-court-case-form-container .hc-array-actions .hc-remove-btn.hc-remove-btn:hover {
  background-color: #dc2626;
}

@media (max-width: 1024px) {
  .high-court-case-form-container .other-court-form-group {
    flex-direction: column;
    gap: 0.5rem;
  }
}
@media (max-width: 480px) {
  .high-court-case-form-container {
    padding: 0.5rem;
  }
  .high-court-case-form-container form {
    padding: 1rem;
    margin: 0.5rem;
  }
  .high-court-case-form-container .hc-form-header .hc-form-title {
    font-size: 1.125rem;
  }
  .high-court-case-form-container .other-court-form-group input,
  .high-court-case-form-container .other-court-form-group textarea,
  .high-court-case-form-container .other-court-form-group select {
    padding: 0.375rem;
    font-size: 0.8125rem;
  }
  .high-court-case-form-container .submit-btn {
    padding: 0.375rem 0.75rem;
    font-size: 0.8125rem;
  }
}
form {
  animation: hc-fade-in 0.3s ease-out;
}

@keyframes hc-fade-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media print {
  .high-court-case-form-container {
    background: white;
    padding: 0;
  }
  .high-court-case-form-container form {
    box-shadow: none;
    border: 1px solid #000;
  }
  .high-court-case-form-container .submit-btn,
  .high-court-case-form-container .rem-div-btn,
  .high-court-case-form-container .add-div-btn {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/forms/OtherCourtCaseForm/OtherCourtCaseForm.scss"],"names":[],"mappings":"AACA;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;AAAF;AAEE;;EAEE,aAAA;EACA,yBAAA;EACA,kBAAA;AAAJ;AAGE;EACE,oBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AADJ;AAGI;EACE,yBAAA;AADN;AAKE;EACE,oBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AAHJ;AAKI;EACE,yBAAA;AAHN;AAQE;EA5CF;IA6CI,aAAA;EALF;AACF;AAQE;EACE,kBAAA;EACA,mBAAA;AANJ;AAQI;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,iBAAA;AANN;AAQM;EANF;IAOI,kBAAA;EALN;AACF;AAQI;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;AANN;AAWE;EACE,aAAA;EACA,sBAAA;EAEA,cAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,wCAAA;AAVJ;AAYI;EACE,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gCAAA;EACA,eAAA;AAVN;AAaI;EAnBF;IAoBI,aAAA;IACA,YAAA;EAVJ;AACF;AAaE;EACE,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gCAAA;AAXJ;AAaI;EACE,qBAAA;AAXN;AAcI;EACE,gBAAA;AAZN;AAeI;EAhBF;IAiBI,gBAAA;EAZJ;AACF;AAgBE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;AAdJ;AAgBI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AAdN;AAgBM;EACI,aAAA;EACA,YAAA;AAdV;AAiBM;EACE,cAAA;EACA,gBAAA;AAfR;AAkBM;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAhBR;AAoBI;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AAlBN;AAoBM;EACE,oBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,iCAAA;AAlBR;AAoBQ;EACE,yBAAA;AAlBV;AAyBE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAvBJ;AAyBI;EACE,gBAAA;AAvBN;AA0BI;EATF;IAUI,sBAAA;IACA,WAAA;EAvBJ;AACF;AAyBI;EACE,SAAA;EACA,aAAA;EACA,sBAAA;AAvBN;AA0BI;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAxBN;AAyBM;EACE,cAAA;EACA,oBAAA;AAvBR;AA2BI;;;EAGE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AAzBN;AA2BM;;;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAvBR;AA0BM;;;EACE,qBAAA;AAtBR;AAyBM;;;EACE,cAAA;AArBR;AAwBM;;;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AApBR;AAwBI;EACE,gBAAA;EACA,yDAAA;EACA,wCAAA;EACA,4BAAA;EACA,8BAAA;EACA,qBAAA;AAtBN;AAyBI;EACE,eAAA;AAvBN;AAyBM;EACE,eAAA;EACA,YAAA;AAvBR;AAyBQ;EACE,YAAA;AAvBV;AA4BI;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AA1BN;AA+BE;EACE,mBAAA;AA7BJ;AA+BI;EACE,gBAAA;AA7BN;AAgCI;EACE;IACE,sBAAA;IACA,WAAA;EA9BN;AACF;AAkCE;EA8CE,eAAA;EACA,YAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;AA7EJ;AA+EI;EACE,UAAA;EACA,oBAAA;AA7EN;AAgFI;EAzDF;IA0DI,YAAA;IACA,UAAA;IACA,WAAA;IACA,eAAA;EA7EJ;AACF;AA+EI;EACE,qBAAA;EACA,sCAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;AA7EN;AA+EM;EACE,yBAAA;AA7ER;AAkFM;EACE,wBAAA;AAhFR;AAoFM;EACE,aAAA;AAlFR;AAuFM;EACE,YAAA;EACA,mBAAA;EACA,eAAA;AArFR;AAuFQ;EAEE,eAAA;AAtFV;AA2FM;EA1CF;IA2CI,WAAA;IACA,mBAAA;IACA,gBAAA;IACA,kBAAA;IACA,yBAAA;EAxFN;AACF;AA4FE;EACE,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,6BAAA;AA1FJ;AA4FI;EANF;IAOI,sBAAA;EAzFJ;AACF;AA2FI;EACE,qBAAA;EACA,sCAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAzFN;AA2FM;EACE,yBAAA;AAzFR;AA4FM;EACE,0BAAA;AA1FR;AA6FM;EACE,aAAA;AA3FR;AA+FM;EACE,YAAA;EACA,mBAAA;AA7FR;AAgGM;EA/BF;IAgCI,WAAA;IACA,gBAAA;EA7FN;AACF;AAkGE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;EACA,mBAAA;AAhGJ;AAkGI;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;AAhGN;AAqGE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAnGJ;AAqGI;;EAEE,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;AAnGN;AAqGM;;EACE,yBAAA;EACA,YAAA;AAlGR;AAoGQ;;EACE,yBAAA;AAjGV;AAqGM;;EACE,yBAAA;EACA,YAAA;AAlGR;AAoGQ;;EACE,yBAAA;AAjGV;;AAyGA;EAEI;IACE,sBAAA;IACA,WAAA;EAvGJ;AACF;AA2GA;EACE;IACE,eAAA;EAzGF;EA2GE;IACE,aAAA;IACA,cAAA;EAzGJ;EA4GE;IACE,mBAAA;EA1GJ;EA8GI;;;IAGE,iBAAA;IACA,oBAAA;EA5GN;EAgHE;IACE,yBAAA;IACA,oBAAA;EA9GJ;AACF;AAmHA;EACE,mCAAA;AAjHF;;AAoHA;EACE;IACE,UAAA;IACA,2BAAA;EAjHF;EAoHA;IACE,UAAA;IACA,wBAAA;EAlHF;AACF;AAsHA;EACE;IACE,iBAAA;IACA,UAAA;EApHF;EAsHE;IACE,gBAAA;IACA,sBAAA;EApHJ;EAuHE;;;IAGE,aAAA;EArHJ;AACF","sourcesContent":["// Main Container\r\n.high-court-case-form-container {\r\n  min-height: 100vh;\r\n  background: #f9fafb;\r\n  padding: 2rem;\r\n\r\n  .rem-div-btn,\r\n  .add-div-btn {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    margin-top: 0.5rem;\r\n  }\r\n  \r\n  .court-remove-case {\r\n    padding: 0.5rem 1rem;\r\n    background-color: #e74c3c;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 0.25rem;\r\n    font-size: 0.875rem;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n\r\n    &:hover {\r\n      background-color: #dc2626;\r\n    }\r\n  }\r\n\r\n  .court-add-case {\r\n    padding: 0.5rem 1rem;\r\n    background-color: #5cb85c;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 0.25rem;\r\n    font-size: 0.875rem;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n    margin-top: 0.5rem;\r\n\r\n    &:hover {\r\n      background-color: #16a34a;\r\n    }\r\n  }\r\n\r\n\r\n  @media (max-width: 768px) {\r\n    padding: 1rem;\r\n  }\r\n\r\n  // Header Section\r\n  .hc-form-header {\r\n    text-align: center;\r\n    margin-bottom: 2rem;\r\n    \r\n    .hc-form-title {\r\n      font-weight: 500;\r\n      color: #374151;\r\n      margin-bottom: 0.5rem;\r\n      font-size: 1.3rem;\r\n\r\n      @media (max-width: 768px) {\r\n        font-size: 1.25rem;\r\n      }\r\n    }\r\n\r\n    .hc-form-subtitle {\r\n      font-size: 0.875rem;\r\n      color: #6b7280;\r\n      font-weight: 400;\r\n    }\r\n  }\r\n\r\n  // Form Styling\r\n  form {\r\n    display: flex;\r\n    flex-direction: column;\r\n    // max-width: 48rem;\r\n    margin: 0 auto;\r\n    padding: 1.5rem;\r\n    background-color: #ffffff;\r\n    border: 1px solid #e5e7eb;\r\n    border-radius: 0.375rem;\r\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n\r\n    h2 {\r\n      font-weight: 500;\r\n      margin: 0 0 1rem 0;\r\n      padding-bottom: 0.5rem;\r\n      border-bottom: 1px solid #e5e7eb;\r\n      font-size: 1rem;\r\n    }\r\n\r\n    @media (max-width: 768px) {\r\n      padding: 1rem;\r\n      margin: 1rem;\r\n    }\r\n  }\r\n  \r\n  .div-rem {\r\n    background: #f9fafb;\r\n    border-radius: 0.375rem;\r\n    padding: 1rem;\r\n    margin-bottom: 1rem;\r\n    border: 1px solid #f3f4f6;\r\n    transition: all 0.3s ease-in-out; // Added for smooth collapse animation\r\n\r\n    &.collapsed {\r\n      padding: 0.75rem 1rem;\r\n    }\r\n\r\n    &:last-child {\r\n      margin-bottom: 0;\r\n    }\r\n\r\n    @media (max-width: 768px) {\r\n      padding: 0.75rem;\r\n    }\r\n  }\r\n\r\n  // <-- ADD THIS ENTIRE BLOCK for the summary view -->\r\n  .summary-view {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    width: 100%;\r\n    gap: 1rem;\r\n\r\n    .summary-details {\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 1rem;\r\n      flex-wrap: wrap;\r\n      font-size: 0.875rem;\r\n      overflow: hidden;\r\n\r\n      .summary-item {\r\n          display: flex;\r\n          gap: 0.35rem;\r\n      }\r\n\r\n      .summary-label {\r\n        color: #6b7280;\r\n        font-weight: 500;\r\n      }\r\n\r\n      .summary-value {\r\n        color: #111827;\r\n        font-weight: 400;\r\n        white-space: nowrap;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n      }\r\n    }\r\n\r\n    .summary-actions {\r\n      display: flex;\r\n      gap: 0.5rem;\r\n      align-items: center;\r\n      \r\n      .edit-btn {\r\n        padding: 0.5rem 1rem;\r\n        background-color: #3b82f6;\r\n        color: white;\r\n        border: none;\r\n        border-radius: 0.25rem;\r\n        font-size: 0.875rem;\r\n        font-weight: 500;\r\n        cursor: pointer;\r\n        white-space: nowrap;\r\n        transition: background-color 0.2s;\r\n\r\n        &:hover {\r\n          background-color: #2563eb;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n\r\n  .other-court-form-group {\r\n    display: flex;\r\n    gap: 1rem;\r\n    margin-bottom: 1rem;\r\n\r\n    &:last-child {\r\n      margin-bottom: 0;\r\n    }\r\n\r\n    @media (max-width: 768px) {\r\n      flex-direction: column;\r\n      gap: 0.5rem;\r\n    }\r\n\r\n    .form-det {\r\n      flex: 1;\r\n      display: flex;\r\n      flex-direction: column;\r\n    }\r\n\r\n    label {\r\n      display: block;\r\n      margin-bottom: 0.5rem;\r\n      font-weight: 500;\r\n      font-size: 0.875rem;\r\n      color: #374151;\r\n      .user-form-required {\r\n        color: #ef4444;\r\n        margin-left: 0.25rem;\r\n      }\r\n    }\r\n\r\n    input,\r\n    textarea,\r\n    select {\r\n      width: 100%;\r\n      padding: 0.5rem;\r\n      border: 1px solid #d1d5db;\r\n      border-radius: 0.25rem;\r\n      font-size: 0.875rem;\r\n      font-family: inherit;\r\n      color: #374151;\r\n      background: #ffffff;\r\n      box-sizing: border-box;\r\n      height: 2.5rem;\r\n\r\n      &:focus {\r\n        outline: none;\r\n        border-color: #3b82f6;\r\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\r\n      }\r\n\r\n      &:hover:not(:focus) {\r\n        border-color: #9ca3af;\r\n      }\r\n\r\n      &::placeholder {\r\n        color: #9ca3af;\r\n      }\r\n\r\n      &:disabled {\r\n        background-color: #f9fafb;\r\n        color: #6b7280;\r\n        cursor: not-allowed;\r\n      }\r\n    }\r\n\r\n    select {\r\n      appearance: none;\r\n      background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\r\n      background-position: right 0.5rem center;\r\n      background-repeat: no-repeat;\r\n      background-size: 1.5rem 1.5rem;\r\n      padding-right: 2.5rem;\r\n    }\r\n\r\n    input[type=\"date\"] {\r\n      cursor: pointer;\r\n\r\n      &::-webkit-calendar-picker-indicator {\r\n        cursor: pointer;\r\n        opacity: 0.6;\r\n\r\n        &:hover {\r\n          opacity: 0.8;\r\n        }\r\n      }\r\n    }\r\n\r\n    textarea {\r\n      height: auto;\r\n      min-height: 4rem;\r\n      resize: vertical;\r\n      line-height: 1.5;\r\n    }\r\n  }\r\n\r\n  // Form Rows for Dynamic Fields\r\n  .form-row {\r\n    margin-bottom: 1rem;\r\n\r\n    &:last-child {\r\n      margin-bottom: 0;\r\n    }\r\n\r\n    @media (max-width: 768px) {\r\n      .other-court-form-group {\r\n        flex-direction: column;\r\n        gap: 0.5rem;\r\n      }\r\n    }\r\n  }\r\n\r\n  .oc-submit-section {\r\n    // display: flex;\r\n    // justify-content: center;\r\n    // margin-top: 1.5rem;\r\n    // border-top: 1px solid #e5e7eb;\r\n\r\n    // @media (max-width: 768px) {\r\n    //   flex-direction: column;\r\n    // }\r\n\r\n    // .submit-btn {\r\n    //   padding: 1rem 1.5rem;\r\n    //   background-color: #5cb85c;\r\n    //   color: white;\r\n    //   border: none;\r\n    //   border-radius: 0.25rem;\r\n    //   font-size:1rem;\r\n    //   font-weight: 500;\r\n    //   cursor: pointer;\r\n    //   min-width: 150px;\r\n    //   margin: 1.5rem auto 0;\r\n    //   display: block;\r\n\r\n    //   &:hover {\r\n    //     background-color: #16a34a;\r\n    //   }\r\n\r\n    //   &:active {\r\n    //     transform: translateY(1px);\r\n    //   }\r\n\r\n    //   &:focus {\r\n    //     outline: none;\r\n    //     box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.3);\r\n    //   }\r\n\r\n    //   &:disabled {\r\n    //     opacity: 0.6;\r\n    //     cursor: not-allowed;\r\n    //   }\r\n\r\n    //   @media (max-width: 768px) {\r\n    //     width: 100%;\r\n    //     margin-top: 1rem;\r\n    //   }\r\n    // }\r\n    position: fixed;\r\n    bottom: 2rem;\r\n    left: 88%;\r\n    transform: translateX(-149.5%);\r\n    z-index: 1000;\r\n    //transition: opacity 0.3s ease; // Added transition for smooth hiding\r\n    &.hidden {\r\n      opacity: 0;\r\n      pointer-events: none;\r\n    }\r\n\r\n    @media (max-width: 768px) {\r\n      bottom: 1rem;\r\n      left: 1rem;\r\n      right: 1rem;\r\n      transform: none;\r\n    }\r\n\r\n    .submit-btn {\r\n      padding: 0.75rem 1rem;\r\n      background-color: var(--primary-color);\r\n      color: white;\r\n      border: none;\r\n      border-radius: 0.25rem;\r\n      font-size: 1rem;\r\n      font-weight: 500;\r\n      cursor: pointer;\r\n      min-width: 150px;\r\n      margin: 1.5rem auto 0;\r\n      display: block;\r\n\r\n      &:hover {\r\n        background-color: #005a9a;\r\n        // box-shadow: 0 6px 20px rgba(92, 184, 92, 0.4);\r\n        //transform: translateY(-2px);\r\n      }\r\n\r\n      &:active {\r\n        transform: translateY(0);\r\n        //box-shadow: 0 2px 8px rgba(92, 184, 92, 0.3);\r\n      }\r\n\r\n      &:focus {\r\n        outline: none;\r\n        // box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.3),\r\n        //   0 4px 12px rgba(92, 184, 92, 0.3);\r\n      }\r\n\r\n      &:disabled {\r\n        opacity: 0.7;\r\n        cursor: not-allowed;\r\n        transform: none;\r\n\r\n        &:hover {\r\n          //background-color: #5cb85c;\r\n          transform: none;\r\n          //box-shadow: 0 4px 12px rgba(92, 184, 92, 0.3);\r\n        }\r\n      }\r\n\r\n      @media (max-width: 768px) {\r\n        width: 100%;\r\n        border-radius: 25px;\r\n        min-width: unset;\r\n        font-size: 0.95rem;\r\n        padding: 0.875rem 1.25rem;\r\n      }\r\n    }\r\n  }\r\n\r\n  .oc-submit-section-form {\r\n    display: flex;\r\n    justify-content: end;\r\n    margin-top: 1.5rem;\r\n    border-top: 1px solid #e5e7eb;\r\n\r\n    @media (max-width: 768px) {\r\n      flex-direction: column;\r\n    }\r\n\r\n    .submit-btn {\r\n      padding: 0.75rem 1rem;\r\n      background-color: var(--primary-color);\r\n      color: white;\r\n      border: none;\r\n      border-radius: 0.25rem;\r\n      font-size: 1rem;\r\n      font-weight: 500;\r\n      cursor: pointer;\r\n      min-width: 150px;\r\n      margin-top: 1rem;\r\n      display: block;\r\n\r\n      &:hover {\r\n        background-color: #005a9a;\r\n      }\r\n\r\n      &:active {\r\n        transform: translateY(1px);\r\n      }\r\n\r\n      &:focus {\r\n        outline: none;\r\n        //box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.3);\r\n      }\r\n\r\n      &:disabled {\r\n        opacity: 0.6;\r\n        cursor: not-allowed;\r\n      }\r\n\r\n      @media (max-width: 768px) {\r\n        width: 100%;\r\n        margin-top: 1rem;\r\n      }\r\n    }\r\n  }\r\n\r\n  // Empty State for Dynamic Arrays\r\n  .hc-empty-state {\r\n    text-align: center;\r\n    padding: 2rem;\r\n    background: #f9fafb;\r\n    border-radius: 0.375rem;\r\n    border: 2px dashed #e5e7eb;\r\n    margin-bottom: 1rem;\r\n\r\n    .hc-empty-text {\r\n      color: #6b7280;\r\n      font-style: italic;\r\n      font-size: 0.875rem;\r\n    }\r\n  }\r\n\r\n  // Action Buttons for Dynamic Arrays\r\n  .hc-array-actions {\r\n    display: flex;\r\n    gap: 1rem;\r\n    margin-bottom: 1rem;\r\n\r\n    .hc-add-btn,\r\n    .hc-remove-btn {\r\n      padding: 0.375rem 0.75rem;\r\n      border-radius: 0.25rem;\r\n      font-size: 0.875rem;\r\n      font-weight: 500;\r\n      cursor: pointer;\r\n      border: none;\r\n\r\n      &.hc-add-btn {\r\n        background-color: #5cb85c;\r\n        color: white;\r\n\r\n        &:hover {\r\n          background-color: #16a34a;\r\n        }\r\n      }\r\n\r\n      &.hc-remove-btn {\r\n        background-color: #e74c3c;\r\n        color: white;\r\n\r\n        &:hover {\r\n          background-color: #dc2626;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Responsive Design\r\n@media (max-width: 1024px) {\r\n  .high-court-case-form-container {\r\n    .other-court-form-group {\r\n      flex-direction: column;\r\n      gap: 0.5rem;\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .high-court-case-form-container {\r\n    padding: 0.5rem;\r\n\r\n    form {\r\n      padding: 1rem;\r\n      margin: 0.5rem;\r\n    }\r\n\r\n    .hc-form-header .hc-form-title {\r\n      font-size: 1.125rem;\r\n    }\r\n\r\n    .other-court-form-group {\r\n      input,\r\n      textarea,\r\n      select {\r\n        padding: 0.375rem;\r\n        font-size: 0.8125rem;\r\n      }\r\n    }\r\n\r\n    .submit-btn {\r\n      padding: 0.375rem 0.75rem;\r\n      font-size: 0.8125rem;\r\n    }\r\n  }\r\n}\r\n\r\n// Animation for form appearance\r\nform {\r\n  animation: hc-fade-in 0.3s ease-out;\r\n}\r\n\r\n@keyframes hc-fade-in {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(10px);\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n// Print styles\r\n@media print {\r\n  .high-court-case-form-container {\r\n    background: white;\r\n    padding: 0;\r\n\r\n    form {\r\n      box-shadow: none;\r\n      border: 1px solid #000;\r\n    }\r\n\r\n    .submit-btn,\r\n    .rem-div-btn,\r\n    .add-div-btn {\r\n      display: none;\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
